import styled from "styled-components";

export const PopUpWidgetContainer = styled.div<{
  variant: 'popup' | 'sticky';
  widgetposition?: string;
  border: any;
  bordercolor: any;
  bottommargin?: number;
  topmargin?: number;
  leftmargin?: number;
  rightmargin?: number;
  buttontopmargin: any;
  buttonrightmargin: any;
  showbuttonborder: any;
  bordersize: any;
  buttonsize: any;
  buttoncolor: any;
  buttonbordercolor: any;
  buttonfill: any;
  width?: string;
  height?: string;
  id?: string;
}>`
  display: flex;
  align-items: stretch;
  position: ${(props) => (props.id ? "fixed" : "absolute")};
  z-index: 1000000;
  box-shadow: 0 6px 55px -10px rgba(0, 0, 0, 0.7);
  border: ${(props) => (props.border ? `2px solid ${props.bordercolor}` : "none")};

  ${({ variant, widgetposition, topmargin, bottommargin, leftmargin, rightmargin, width = "auto", height = "auto", id }) => `
    ${variant === 'popup' ? `
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      max-width: 90vw;
      max-height: 90vh;
    ` : `
      ${widgetposition?.includes("top") ? `top: ${topmargin || 0}px;` : ""}
      ${widgetposition?.includes("bottom") ? `bottom: ${bottommargin || 0}px;` : ""}
      ${widgetposition?.includes("right") ? `right: ${rightmargin || 0}px;` : ""}
      ${widgetposition?.includes("left") ? `left: ${leftmargin || 0}px;` : ""}
      ${widgetposition?.includes("center") ? `
        left: 50%;
        transform: translateX(-50%);
      ` : ""}
      width: ${width};
      height: ${height};
      max-width: ${id ? "40vw" : "9vw"};
      max-height: ${id ? "90vh" : "15vh"};
    `}
  `}

  /* Animation Classes */
  &.bottom-in {
    animation: slide_to_top 2s ease forwards;
  }
  &.left-in {
    animation: slide_to_right 2s ease forwards;
  }
  &.right-in {
    animation: slide_to_left 2s ease forwards;
  }
  &.top-in {
    animation: slide_from_top 2s ease forwards;
  }

  /* Keyframes */
  @keyframes slide_to_top {
    0% { bottom: -100%; }
    100% { bottom: ${(props) => props.bottommargin || 0}px; opacity: 1; }
  }
  @keyframes slide_to_right {
    0% { left: -100%; }
    100% { left: ${(props) => props.leftmargin || 0}px; opacity: 1; }
  }
  @keyframes slide_to_left {
    0% { right: -100%; }
    100% { right: ${(props) => props.rightmargin || 0}px; opacity: 1; }
  }
  @keyframes slide_from_top {
    0% { top: -100%; }
    100% { top: ${(props) => props.topmargin || 0}px; opacity: 1; }
  }

  /* Close button styles */
  .iiris-popup-close-btn {
    position: absolute;
    top: ${(props) => props.buttontopmargin || 4}px;
    right: ${(props) => props.buttonrightmargin || 4}px;
    z-index: 10;

    .close-popup {
      color: ${(props) => props.buttoncolor || "inherit"};
      background-color: ${(props) => props.buttonfill || "transparent"};
      border-radius: 50%;
      cursor: pointer;
      width: ${(props) => props.buttonsize || "1.4"}rem;
      height: ${(props) => props.buttonsize || "1.4"}rem;
      border: ${(props) =>
        !props.showbuttonborder
          ? "none"
          : `${props.bordersize}rem solid ${props.buttonbordercolor || "inherit"}`};
    }
  }
`;

export const Image = styled.img`
  object-fit: contain;
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
`;

export const BannerContainer = styled.div<{
  maxWidth: any;
  mediaPosition: any;
  fontSize1: any;
  fontSize2: any;
  background: any;
}>`
  overflow: hidden;
  margin: 1px;
  display: flex;
  flex-direction: column;
  max-width: ${(props) => props.maxWidth}px;
  align-items: ${(props) =>
    ["left", "right"].includes(props.mediaPosition) ? "center" : "initial"};

  .iiris-banner-imagecontainer {
    position: relative;
    display: flex;
    order: initial;

    @media (min-width: 768px) {
      order: ${(props) =>
        ["bottom", "right"].includes(props.mediaPosition) ? "2" : "initial"};
    }
  }

  .iiris-banner-contentcontainer {
    .content-heading {
      font-size: ${(props) => props.fontSize1}px;
    }

    .content-description {
      font-size: ${(props) => props.fontSize2}px;
    }
  }

  .iiris-banner-imagecontainer::after {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: linear-gradient(
      90deg,
      ${(props) => props.background} 3%,
      rgba(29, 45, 53, 0) 30%,
      rgba(29, 45, 53, 0) 70%,
      ${(props) => props.background} 97.5%
    );
  }

  @media (min-width: 370px) {
    flex-direction: ${(props) =>
      ["top", "bottom"].includes(props.mediaPosition) ? "column" : "row"};
    align-items: initial;
  }
`;

export const BannerAds = styled.div`
  justify-content: center;
  display: flex;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const Loader = styled.div<{ primaryColor?: any }>`
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid ${(props) => props.primaryColor};
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;